import { visualSweepsConfig } from '@labrain/engine-staircase';
export const staircaseConfig = {
    ...visualSweepsConfig,
    // MVP : 24 essais max, < 3 min test live.
    maxTrials: 24,
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
};
export const DIRECTIONS = ['up', 'down', 'left', 'right'];
export const DIRECTION_LABELS = {
    up: '↑',
    down: '↓',
    left: '←',
    right: '→',
};
function buildVariant(level) {
    if (level <= 10) {
        return { level, coherence: 0.8, nDots: 80, label: 'Mouvement net' };
    }
    if (level <= 20) {
        return { level, coherence: 0.5, nDots: 120, label: 'Signal moyen' };
    }
    if (level <= 30) {
        return { level, coherence: 0.3, nDots: 160, label: 'Filtrage actif' };
    }
    if (level <= 40) {
        return { level, coherence: 0.2, nDots: 200, label: 'Limite MT' };
    }
    return { level, coherence: 0.15, nDots: 240, label: 'Trace de mouvement' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
/** Durées non-staircase. */
export const timing = {
    fixationMs: 500,
    maskMs: 200,
    itiMs: 700,
    /** Floor : si staircase descend en-dessous, cap à 1 frame @60Hz. */
    minRenderMs: 17,
};
export const paradigmMeta = {
    slug: 'visual-sweeps',
    paradigm: 'Random-Dot Kinematogram (Newsome & Pare 1988)',
    masterMage: 'Inori (attention-air) + Embra (vivacité)',
    category: 'feu_vivacite',
    goal: 'Détection mouvement périphérique — anticipation trajectoires, sport, conduite.',
};
//# sourceMappingURL=params.js.map